import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import "../Styling/Home.css";
import PendingTimecardsWordCloud from "../Components/PendingTimecardsWordCloud";
import DailyTimecardsReport from "../Components/DailyTimecardsReport";
import Reports from "./Reports.js/Reports";
import { useAuth } from "../Context/AuthContext";
import PunchInMaster from "./PunchInMaster";
 import HrDashboardDropdownDynamic from "./Reports.js/HrDashboard";
const Home = () => {
const { user } = useAuth();
const roles = user?.roles || [];
const hr=roles.includes("HR");
const isExecutive = roles.includes("Executive") || roles.includes("SD_Employee");
if(hr)
{
  return <HrDashboardDropdownDynamic user={user}/>
}
if (isExecutive) {
  return <PunchInMaster />;
}

  return (
    <Reports/>
    // <div className="main-content expand">
    //   <div className="dashboard-overview-container">
    //     <h2 className="home-title">Dashboard Overview</h2>

    //     <Row className="mt-4 g-3">
    //       <Col md={6}>
    //         <Card className="timecard-card">
    //           <Card.Header>
    //             <Card.Title>Pending Ticket Timecards</Card.Title>
    //           </Card.Header>
    //           <Card.Body>
    //             <PendingTimecardsWordCloud />
    //           </Card.Body>
    //         </Card>
    //       </Col>

    //       <Col md={6}>
    //         <Card className="timecard-card">
    //           <Card.Header>
    //             <Card.Title>Pending Daily Timecards</Card.Title>
    //           </Card.Header>
    //           <Card.Body>
    //             <DailyTimecardsReport />
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    //   </div>
    // </div>
  );
};

export default Home;
